import React, { useEffect, useState, useRef } from 'react';
import { Calendar, ChevronDown } from 'lucide-react';
const OPTIONS = ['Questo mese', 'Ultimi 30 giorni', 'Trimestre', 'Range personalizzato'];
export function PeriodSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(OPTIONS[0]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-933">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-2 bg-white/[0.03] hover:bg-white/[0.06] border border-white/[0.08] rounded-lg transition-all" data-id="element-934">
        <Calendar className="w-4 h-4 text-white/70" data-id="element-935" />
        <span className="text-[13px] font-medium text-white" data-id="element-936">{selected}</span>
        <ChevronDown className="w-4 h-4 text-white/40" data-id="element-937" />
      </button>

      {isOpen && <div className="absolute top-full right-0 mt-2 w-48 bg-[#1a1a1a] border border-white/[0.08] rounded-lg shadow-xl overflow-hidden z-50" data-id="element-938">
          <div className="py-1" data-id="element-939">
            {OPTIONS.map(option => <button key={option} onClick={() => {
          setSelected(option);
          setIsOpen(false);
        }} className={`w-full text-left px-4 py-2 text-[13px] transition-colors ${selected === option ? 'bg-white/[0.06] text-white font-medium' : 'text-white/70 hover:bg-white/[0.03] hover:text-white'}`} data-id="element-940">
                {option}
              </button>)}
          </div>
        </div>}
    </div>;
}